export default __webpack_public_path__ + "static/hero-layer-1-77c4e20efe471e825d24647a0d08c25c.svg";